//import StorageUtils from './storage';
import FirestoreUtils from './firestore';

export default {

    deleteVideoLike (videoLike, adminId) {
        return FirestoreUtils.deleteVideoLike(videoLike, adminId);
    },

    validVideoLike (videoLike, adminId) {
        return FirestoreUtils.validVideoLike(videoLike, adminId);
    },
};